import { getQueryClient } from '../../provider/get-query-client'
import type {
  AdminDeleteLocationParams,
  UserGetCitiesRequest,
  UserGetCountiesRequest,
  UserGetDistrictsRequest,
  AdminSetLocationInput,
} from '../api'
import locationService from './location.service'
import { ELocationQueryKey } from './location.types'

export const getProvincesOptions = () => {
  return {
    queryKey: [ELocationQueryKey.GET_PROVINCES],
    queryFn: () => locationService.getProvinces(),
  }
}

export const getCountiesOptions = (filter: UserGetCountiesRequest) => {
  return {
    queryKey: [ELocationQueryKey.GET_COUNTIES, filter],
    queryFn: () => locationService.getCounties(filter),
    enabled: !!filter.provinceID,
  }
}

export const getCitiesOptions = (filter: UserGetCitiesRequest) => {
  return {
    queryKey: [ELocationQueryKey.GET_CITIES, filter],
    queryFn: () => locationService.getCities(filter),
    enabled: !!filter.countyID && !!filter.provinceID,
  }
}

export const getDistrictsOptions = (filter: UserGetDistrictsRequest) => {
  return {
    queryKey: [ELocationQueryKey.GET_DISTRICTS, filter],
    queryFn: () => locationService.getDistricts(filter),
    enabled: !!filter.countyID && !!filter.provinceID,
  }
}

export const adminSaveLocationOptions = (data: AdminSetLocationInput) => {
  return {
    mutationKey: [ELocationQueryKey.GET_DISTRICTS, data],
    mutationFn: (data: AdminSetLocationInput) =>
      locationService.adminSaveLocation(data),
    onSuccess: () => {
      const queryClient = getQueryClient()

      // Invalidate all location-related queries
      const locationQueryKeys = [
        ELocationQueryKey.GET_PROVINCES,
        ELocationQueryKey.GET_COUNTIES,
        ELocationQueryKey.GET_CITIES,
        ELocationQueryKey.GET_DISTRICTS,
      ]

      locationQueryKeys.forEach((key) => {
        queryClient.invalidateQueries({
          queryKey: [key],
        })
      })
    },
  }
}

export const adminDeleteLocationOptions = (data: AdminDeleteLocationParams) => {
  return {
    mutationKey: [ELocationQueryKey.GET_DISTRICTS, data],
    mutationFn: (data: AdminDeleteLocationParams) =>
      locationService.adminDeleteLocation(data),
    onSuccess: () => {
      const queryClient = getQueryClient()

      // Invalidate all location-related queries
      const locationQueryKeys = [
        ELocationQueryKey.GET_PROVINCES,
        ELocationQueryKey.GET_COUNTIES,
        ELocationQueryKey.GET_CITIES,
        ELocationQueryKey.GET_DISTRICTS,
      ]

      locationQueryKeys.forEach((key) => {
        queryClient.invalidateQueries({
          queryKey: [key],
        })
      })
    },
  }
}
